module.exports = __webpack_public_path__ + "7e4b29ba/img/question-icon.06c20c5d.svg";